<template>
  <div id="app">
    <v-app>
      <!-- CHAMADA DO TOOLBAR -->
      <Toolbar />
      <v-main>           
        <!-- CHAMADA DO CONTEUDO -->          
        <Content />                              
      </v-main>
      <!-- CHAMADA DO FOOTER -->
      <Footer />
    </v-app>
  </div>
</template>

<script>
  import Footer from '../componentes/footer.vue'
  import Toolbar from '../componentes/toolbar.vue'
  import Content from '../componentes/content.vue'
  import { mapState } from "vuex"
  export default {
    name: 'app',
    components: {Footer, Toolbar, Content},
    computed: {
      ...mapState({
        usuarioadmin: state => state.Userpermission,
      })
    },
    data () {
      return {
      }
    },
  }
</script>

<style>
  @font-face {
    font-family: Roboto;
    src: url('../assets/Roboto-Regular.ttf');
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #1f2433;
    font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;
  }

  /* Fundo suave e moderno para toda a área autenticada */
  .v-application {
    background: #f4f6fb !important;
  }
  .v-main {
    background: #f4f6fb;
  }

  #app h1 {
    text-align: center;
    margin: 50px;
  }

  html {
    overflow: auto;
  }

  .v-tabs-bar.v-item-group {
    height: 38px;
  }

  .v-tab--active {
    background-color: white !important;
    color: grey !important;
    border-radius: 5px 5px 0 0 !important;
  }

  .v-tab {
    border-radius: 5px 5px 0 0;
    background-color: #00253E;
    color: white;
  }

  @media only screen and (min-width: 550px) {
    .v-tab {
      min-width: 130px;
    }
    
    .v-tabs-bar.v-item-group {
      max-width: 400px;
    }
    
    .v-tab:nth-child(3) {
      border-radius: 0 5px 0 0;
    }

    .v-tab:nth-child(2) {
      border-radius: 5px 0 0 0;
    }
    
    .v-tabs-bar.v-item-group {
      background-color: #00253E !important;
      border-radius: 10px 10px 0 0;
      color: white;
    }
  }

  .theme--dark.v-tabs>.v-tabs-bar .v-tab--disabled, .theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon {
    color: white;
  }

  .theme--dark.v-tabs .v-tab--active:before, .theme--dark.v-tabs .v-tab--active:hover:before, .theme--dark.v-tabs .v-tab:focus:before {
    opacity: 0;
  }

  .v-tabs-slider {
    display: none;
  }

  /* ===================== PLATAFORMA — estilos compartilhados ===================== */
  .ai-page {
    padding: 20px 24px 28px;
    max-width: 1400px;
  }
  .ai-toolbar-select {
    max-width: 380px;
  }
  .ai-panel {
    background: #fff;
    border: 1px solid #eef1f6;
    border-radius: 14px !important;
    overflow: hidden;
  }
  .ai-panel__head {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 20px;
    flex-wrap: wrap;
    border-bottom: 1px solid #eef1f6;
  }
  .ai-panel__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.1rem;
    font-weight: 700;
    color: #0f0f41;
  }
  .ai-panel__title .v-icon {
    color: #038b8b;
  }
  .ai-count {
    background: rgba(3, 139, 139, 0.12);
    color: #038b8b;
    font-size: 0.76rem;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 999px;
  }
  .ai-panel__spacer {
    flex: 1 1 auto;
  }
  .ai-search {
    max-width: 260px;
  }

  /* Data tables modernas */
  .ai-datatable {
    background: transparent !important;
  }
  .ai-datatable .v-data-table-header th,
  .ai-datatable thead tr th {
    background: #f7f9fc !important;
    color: #5b6478 !important;
    font-weight: 700 !important;
    font-size: 0.76rem !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
    border-bottom: 1px solid #eef1f6 !important;
  }
  .ai-datatable tbody tr:hover {
    background: #f6fafb !important;
  }
  .ai-datatable td {
    font-size: 0.9rem !important;
    color: #2c3344;
  }

  /* Diálogos modernos */
  .ai-dialog .v-card {
    border-radius: 16px !important;
    overflow: hidden;
  }
  .ai-dialog .v-card > .v-card__title {
    background: linear-gradient(90deg, #0f0f41 0%, #1a1b57 100%);
    color: #fff !important;
    font-weight: 700;
    font-size: 1.05rem;
    padding: 16px 22px;
  }
  .ai-dialog .v-card > .v-card__title .v-icon {
    color: #fff;
    margin-right: 8px;
  }
  .ai-dialog-body {
    padding: 22px !important;
  }
  .ai-dialog .v-card__actions {
    padding: 12px 20px 18px;
  }

  /* Status chip */
  .ai-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.8rem;
    font-weight: 600;
  }
</style>
